      <template>
        <div class="container pt-5 mt-2">
<!--          上部分 -->
            <div class="address-detail">

    <!--          左部分-->
                <div class="address-box-left">
                  <div class="address-box-icon">
                    <img v-if="accountList && accountList.isContract==1" src="../../images/address/contrac-red.png"/>
                    <img v-else src="../../images/address/Avatar.png"/>
                  </div>
                  <div v-if="accountList && accountList.isContract==1" class="address-box-left-title">
                    <span v-if="accountList.contract.name && accountList.contract.name != ''">
                      <router-link style="font-size: 18px" :to="`/token/${accountList.contract.address}`">
                        {{accountList.contract.name}} ({{accountList.contract.symbol}})
                      </router-link>
                    </span>
                    <span v-else>
                      Contract
                    </span>
                  </div>
                  <div v-else>
                    <div class="address-box-left-title">Account Details</div>
                  </div>
                  <div v-if="accountList.isContract!=1" class="address-box-left-text">
                    <div class="address-box-copy">{{updateAddress(address)}}<Copy :data="address"/></div>
                  </div>
                  <div v-if="accountList && accountList.isContract==1">
                    <div class="address-box-left-text" style="padding-top: 5px">
                      <div class="address-box-copy">{{updateAddress(address)}}<Copy :data="address"/></div>
                    </div>
                      <div v-if="accountList.createHash && accountList.createHash != ''" class="d-flex flex-column align-items-start pt-1" style="font-size: 13px">
                        <span>Contract Creator:</span>
                        <div class="d-flex flex-row align-items-center ">
                          <span><router-link :to="`/address/${accountList.createAddress}`">{{getSortAddress(accountList.createAddress)}}</router-link><span class="px-2">at txn</span></span>
                          <span><router-link :to="`/tx/${accountList.createHash}`">{{getSortAddress(accountList.createHash)}}</router-link></span>
                        </div>

                      </div>
                  </div>
                </div>
    <!--          右部分-->
                <div v-if="accountList" class="address-box-right">
                    <div class="address-box-right-top">
                      <span>MAPO Balance:</span>
                      <span>{{accountList.balance ? accountList.balance : 0 }} MAPO</span>
                    </div>
                    <div class="address-box-line"></div>
                    <div class="address-box-right-token">
                      <div class="address-box-right-token-title">
                        <span>Token Holdings</span>
                        <span>Total {{accountList.tokenTotal ? accountList.tokenTotal : 0 }} tokens</span>
                      </div>
                      <div @click="showTab=3" class="address-box-right-view">
                        <span><img src="../../images/address/view.png"/></span>
                        View expanded token holdings
                      </div>
                    </div>
                    <div class="address-tokens mt-4">
                      <span>MRC20 TOKENS</span>
                      <span>Total {{accountList.erc20Total ? accountList.erc20Total : 0}} Token </span>
                    </div>
                    <div class="address-tokens mt-3">
                      <span>MRC721 TOKENS</span>
                      <span>Total {{accountList.erc721Total ? accountList.erc721Total : 0}} Token (Total {{accountList.nftTotal ? accountList.nftTotal : 0}} NFT)</span>
                    </div>
                </div>

            </div>
<!--            下部分-->
            <div class="address-tab">
                <div @click="showTab=0" :class="showTab==0 ?'address-tab-text-click':''"  class="address-tab-text address-tab-text-one">Transactions</div>
                <div @click="actionInternal(showTab=4)" :class ="showTab==4 ?'address-tab-text-click':''"   class="address-tab-text address-tab-text-five">Internal Txns</div>
                <div @click="actionErcList(showTab=1)" :class="showTab==1 ?'address-tab-text-click':''"  class="address-tab-text address-tab-text-two" >MRC20 Transfers</div>
                <div @click="actionErcList(showTab=2)" :class ="showTab==2 ?'address-tab-text-click':''"   class="address-tab-text address-tab-text-three">MRC721 Transfers</div>
                <div @click="showTab=3" :class ="showTab==3 ?'address-tab-text-click':''"   class="address-tab-text address-tab-text-four">Tokens</div>
                <div @click="showTab=5" :class ="showTab==5 ?'address-tab-text-click':''"   class="address-tab-text address-tab-text-four">NFTs</div>
            </div>

<!--          transaction-->
          <div v-show="showTab==0" class="address-total address-total-one">
            <div>
              <span>Total {{  }} txs</span>
              <span>Show 10 latest records</span>
            </div>

            <router-link :to="`/transaction/${address}`">
              <div class="address-box-right-view">
                  <span><img src="../../images/address/view.png"/></span>
                  View all transactions
              </div>
            </router-link>
          </div>
          <div v-show="showTab==0" class="mt-4">
                <TransactionTable v-if="address" :cfg="cfg" :page="showPage" :type="1" :address="address"/>
          </div>

<!--          erc20-->
            <div v-if="ercTransList" v-show="showTab==1" class="address-total address-total-one">
              <div>
                <span>Total transfers</span>
                <span>Show 10 latest records</span>
              </div>
              <router-link :to="`/mrc20transfers/${address}`">
                <div class="address-box-right-view">
                  <span><img src="../../images/address/view.png"/></span>
                  View all MRC20 transfers
                </div>
              </router-link>
            </div>
            <div v-if="ercTransList" v-show="showTab==1">
              <ErcTransactionTable v-if="address"  :cfg="cfg" :page="showPage" :top="1" :address="address"/>
            </div>

<!--          erc721-->
          <div v-if="ercSevenTransList" v-show="showTab==2" class="address-total address-total-one">
            <div>
              <span>Total transfers</span>
              <span>Show 10 latest records</span>
            </div>
            <router-link :to="`/mrc721transfers/${address}`">
              <div class="address-box-right-view">
                <span><img src="../../images/address/view.png"/></span>
                View all MRC721 transfers
              </div>
            </router-link>
          </div>
          <div v-if="ercSevenTransList" v-show="showTab==2">
            <ErcSevenTransactionTable  v-if="address"  :cfg="cfg" :page="showPage" :top="1"/>
          </div>

<!--          tokens-->
          <div v-if="accountList"  v-show="showTab==3" class="address-total address-total-one">
            <div>
              <span>Total Tokens</span>
              <span>Show 10 latest records</span>
            </div>
            <router-link :to="`/accountToken/${address}`">
              <div class="address-box-right-view">
                <span><img src="../../images/address/view.png"/></span>
                View all Tokens
              </div>
            </router-link>
          </div>
          <div v-if="accountList" v-show="showTab==3" class="mt-4 bg-card">
            <TokenTable v-if="tokenList" :cfg="cfg" :page="showPage" :top="1"/>
          </div>

<!--          internal txns-->
          <div v-if="internalList"  v-show="showTab==4" class="address-total address-total-one">
            <div>
              <span>Total {{internalList.tokenTotal}} transfers</span>
              <span>Show 10 latest records</span>
            </div>

           <router-link :to="`/accountInternal/${address}`">
            <div class="address-box-right-view">
              <span><img src="../../images/address/view.png"/></span>
              View all Internal Txns
            </div>
            </router-link>
          </div>
          <div v-if="internalList" v-show="showTab==4" class="mt-4 bg-card">
            <AccountInternalTxnsTable v-if="internalList" :data="internalList"/>
          </div>

<!--          token NFTs-->
          <div v-show="showTab==5" class="address-total address-total-one">
            <div>
              <span>Total NFTs</span>
              <span>Show 10 latest records</span>
            </div>
            <router-link :to="`/tokenInventory/${address}`">
              <div class="address-box-right-view">
                <span><img src="../../images/address/view.png"/></span>
                View all NFTs
              </div>
            </router-link>
          </div>
          <div v-show="showTab==5">
            <TokenInventory :addressTrans="updateAddress(address)" :page="showPage" :cfg="cfg" :top="1"/>
          </div>


        </div>
      </template>

      <script>
      import { Decimal } from 'decimal.js'
      import TransactionTable from "@/views/comp_table/transaction_table";
      import ErcTransactionTable from "@/views/comp_table/erc_transaction_table";
      import ErcSevenTransactionTable from "@/views/comp_table/ercSeven_transaction_table";
      import TokenTable from "@/views/comp_table/tokens_table";
      import Copy from "@/views/_frame/copy";
      import {updateAddress,getSortAddress} from "@/util";
      import AccountInternalTxnsTable from "@/views/comp_table/account_internal_txs";
      import TokenInventory from "@/views/_comp_token/token_inventory_table";

      export default {
        name: "index",
        components: {
          TokenInventory,
          AccountInternalTxnsTable,
          Copy, TokenTable, ErcSevenTransactionTable, ErcTransactionTable, TransactionTable},
        data() {
          return {
            cfg:{
              'page_size': 10, //每页条目数量
              'page_current': 1, // 当前页
              'count_items': 0, //总个数，和总页数选填其一
              'btn_num': 5, // 按钮个数
              'turnpage_top': true, // 翻页时操作滚动置顶
              'count_pages':0, //总页数，和个页数选填其一 // 默认请给 0 值-便于首次加载时不露出分页器
            },
            accountList: [],//账户墙青
            address:'',//显示地址
            showPage:'showPage',//显示页码
            showTab:0,
            transList: null,//交易列表
            transTotal:0,//交易总数
            ercTransList:null,//erc20列表
            ercSevenTransList:null,//erc721列表
            tokenList:null,//token列表
            internalList:null,//internal列表
          }
        },
        methods:{
          //转换地址
          updateAddress(val){
            if (!val) {
              return
            }
           return  updateAddress(val)
          },
          getSortAddress(val){
            return getSortAddress(val)
          },
          //Tokenlist
          async actionTokenList() {
            let v = this
            let address = {'address': v.address}
            let result=await v.api('accountTokenList',address,{ vue: v,
              key_data: 'data',})
            // console.log('addressDetail',result)
            if (result.code==200){
              v.tokenList=result.data.list
            }
          },
          //账户详情显示
          async actionAccount(){
              let v = this
              let address = {'address': v.address}
              let result=await v.api('accountDetail',address,{ vue: v,
                key_data: 'data',})
              // console.log('addressDetail',result)
              if (result.code==200){
                v.accountList=result.data
                // v.tokenList=result.data.tokenList
                v.accountList.balance=new Decimal(result.data.balance).div(new Decimal(Math.pow(10,18))).toFixed(6)
              }
          },
          //transaction列表
          async actionTransList() {
              let v =this
              let result = await v.api('txsList',{
                page: 1,
                size: 10,
                address:this.address
              },{
                vue: v,
                key_data: 'data',
              })
            // console.log('address-TransactionList',result)
            if (result.code==200) {
              this.transList=result.data.transactionList
            }
          },
          //erc20列表
          async actionErcList() {
            let v = this
            let type = ''
            if (v.showTab==1){
              type=1
            }
            else if (v.showTab==2) {
              type=2
            }
            let result = await v.api('tokenListAddress',{
              page: 1,
              size: 10,
              address:this.address,
              type:type
            },{
              vue: v,
              key_data: 'data',
            })
            // console.log('address-erc',result)
            if (result.code==200) {
              if (v.showTab==1) {
                this.ercTransList=result.data

              }
              else if (v.showTab==2) {
                this.ercSevenTransList=result.data
              }

            }
          },
          //internal txns
          async actionInternal() {
            let v = this
            let result = await v.api('internalTransAddress',{
              page: 1,
              size: 10,
              address:this.address,
            },{
              vue: v,
              key_data: 'data',
            })

            console.log(result)
            if (result.code=200) {
              this.internalList=result.data.list
            }
          },

          getAllData() {
            this.actionTokenList()
            this.actionAccount()
            // this.actionTransList()
          }
        },
        mounted() {
          this.address=this.$route.params.number
          this.getAllData()
        },
      }
      </script>

      <style scoped lang="scss">


      </style>
